const SDK_VERSION = "11.6.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
